/** @format */

import Main from './main.jsx'
import './App.css'

function App() {
	return (
		<div className='App'>
			<Main />
		</div>
	)
}

export default App
